import React from "react";
import { Radio, ExternalLink } from "lucide-react";
import { SOCIALS, KICK_EMBED } from "../mock";

const Livestream = () => {
  return (
    <section id="livestream" className="relative py-24 px-5 bg-[#2f2753]">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#53fc18]/15 border border-[#53fc18]/40 px-4 py-1.5 mb-5">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#53fc18] opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#53fc18]" />
            </span>
            <span className="text-xs font-extrabold tracking-widest text-[#53fc18]">LIVE ON KICK</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white tracking-tight">Watch Me Live</h2>
          <p className="mt-4 text-[#b7b0d6] max-w-xl mx-auto">
            I'm live <span className="text-white font-semibold">(almost) every day</span> on Kick. Catch the streams, big
            wins and giveaways right here from the website.
          </p>
        </div>

        {/* embedded kick player */}
        <div className="rounded-2xl border border-[#473c7d] bg-[#1b1630] overflow-hidden shadow-xl">
          <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
            <iframe
              src={KICK_EMBED}
              title="Broer live on Kick"
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href={SOCIALS.kick}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#53fc18] hover:bg-[#63ff2e] text-[#0e1b0a] font-extrabold rounded-xl px-8 h-14 transition-colors"
          >
            <Radio size={18} /> WATCH ON KICK <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Livestream;
